import api from "../../api";

const state = {
  tasks: null,
  taskUrl: null,
};

const getters = {
  getTaskId: (state) => {
    const id = state.taskUrl.split("/");
    return id[id.length - 1];
  },
};

const mutations = {
  set_taskUrl(state, data) {
    state.taskUrl = data.taskUrl;
  },
};

const actions = {
  createTask({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${data.projectId}/tasks`,
        method: "POST",
        withCredentials: true,
        data: data.task,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  updateTask({ commit, getters, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${data.projectId}/task/${getters.getTaskId}`,
        method: "PUT",
        withCredentials: true,
        data: data.tasks,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getProjectTasks({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${data.projectId}/tasks?offset=${data.offset}&limit=${data.limit}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },
};

export const tasks = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
